export default "/images/framework/CircleGift.108060b7.svg?108060b7";